export default class StudentInput { 
    idCard?: any | null
    carType?: any | null
}